import _ from "lodash";
import React from "react";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";
import { Actions as COMPANY_ACTIONS } from "@/redux/actions/companyActions";
import { Actions as PAYMENT_ACTIONS } from "@/redux/actions/paymentActions";
import AdvisorBundleCard from "../../../billing/AdvisorBundleCard";
import BundleCard from "../../../billing/BundleCard";
import { useEffect } from "react";

const Billing = ({
	existingCompanyDetails,
	advisorBundles,
	nextPage,
	prevPage,
	updateSetting,
	isAdvisor,
	advisorName,
	bundles,
	getBundles,
}) => {
	const { plan, name, advisor, paidByAdvisor } = existingCompanyDetails;

	useEffect(() => {
		if (typeof bundles === "undefined") {
			getBundles();
		}
	}, []);

	const onSubmit = () => {
		if (!plan || (!advisor && plan == "c01a916c-31d4-4e50-8d80-8e36e220be39")) {
			NotificationManager.error("A plan is required!", "Saving Billing Details");
			return;
		}
		nextPage();
	};

	return (
		<div>
			<div className="col-xs-12 form-section">
				<div className="col-xs-6">
					<h4>Billing</h4>
					<p>
						The plan selected below will be paid for by{" "}
						<strong>
							<u>{paidByAdvisor ? advisorName : name}</u>
						</strong>
					</p>
				</div>
				<div className="col-xs-6">
					{advisor && (
						<label className="css-input switch switch-sm switch-success">
							<input
								type="checkbox"
								value={true}
								checked={paidByAdvisor}
								onChange={(e) => {
									// setValue('advisor',e.target.checked ? profile.advisorId : false, { shouldValidate: true,shouldDirty: true });
									updateSetting("paidByAdvisor", e.target.checked, true);
								}}
							/>
							<span /> Invoice {advisorName}
						</label>
					)}
				</div>
			</div>
			<div className="clearfix" />
			<section
				className="billing-page"
				style={{ marginTop: "2rem" }}
			>
				<div>
					<div className="grid grid-cols-3 gap-8">
						{(isAdvisor ? advisorBundles : bundles)?.map((bundle) => (
							<BundleCard
								key={bundle.id}
								bundle={bundle}
								forModal={true}
								updateSetting={updateSetting}
							/>
						))}
					</div>
				</div>
			</section>
			<div className="clearfix" />

			<div style={{ marginTop: 10 }}>
				<a
					href="#"
					className="btn btn-default"
					onClick={prevPage}
				>
					Back
				</a>
				<button
					className="btn btn-success right"
					type="submit"
					onClick={onSubmit}
				>
					Save
				</button>
			</div>
			<div className="clearfix" />
		</div>
	);
};

const mapStateToProps = (state) => {
	const existingCompanyDetails = state.company.newCompany;
	const { currency, plan: selectedPlan } = state.company.newCompany;
	const bundles =
		state.payment.bundles &&
		_.orderBy(
			state.payment.bundles?.filter((b) => b.isPlan && b.advisor != "yes"),
			["credits"],
			["asc"],
		)?.map((item) => {
			const current = item.id == selectedPlan;
			return {
				...item,
				current,
				value: item.id,
				label: `${item.name} - ${currency}${item.price}/employee/mo`,
			};
		});

	const advisorBundles =
		state.payment.bundles &&
		_.orderBy(
			state.payment.bundles?.filter((b) => b.isPlan && b.advisor == "yes"),
			["credits"],
			["asc"],
		)?.map((item) => {
			const current = item.id == selectedPlan;
			return {
				...item,
				current,
				value: item.id,
				label: `${item.name} - ${currency}${item.price}/employee/mo`,
			};
		});

	return {
		bundles,
		advisorBundles,
		advisorName: state?.my?.profile?.advisorName,
		existingCompanyDetails,
		isAdvisor:
			state.my?.profile?.isAdvisor && state.my?.profile?.advisorUnlimited && state.company?.newCompany?.advisor,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	updateSetting: (field, newValue) => dispatch(COMPANY_ACTIONS.updateSetting(field, newValue, true)),
	getBundles: () => dispatch(PAYMENT_ACTIONS.getBundles()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Billing);
